/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Project_TypeInputs */

const en_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Type`)
};

const fr_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de projet`)
};

const de_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekttyp`)
};

const it_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo di progetto`)
};

const ru_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тип проекта`)
};

const es_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de proyecto`)
};

const zh_cn2_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目类型`)
};

const ja_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトの種類`)
};

const hi_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना प्रकार`)
};

const pt_pt2_options_general_project_type = /** @type {(inputs: Options_General_Project_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de projeto`)
};

/**
* | output |
* | --- |
* | "Project Type" |
*
* @param {Options_General_Project_TypeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_project_type = /** @type {((inputs?: Options_General_Project_TypeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Project_TypeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_project_type(inputs)
	if (locale === "de") return de_options_general_project_type(inputs)
	if (locale === "it") return it_options_general_project_type(inputs)
	if (locale === "ru") return ru_options_general_project_type(inputs)
	if (locale === "es") return es_options_general_project_type(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_project_type(inputs)
	if (locale === "ja") return ja_options_general_project_type(inputs)
	if (locale === "hi") return hi_options_general_project_type(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_project_type(inputs)
	return en_options_general_project_type(inputs)
});